module.exports = __webpack_public_path__ + "media/images/common/search_btn_ov-0c1430353bfb81e67d4be79491b72a36.gif";